import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { InheritedLabelsFieldFragment, WorkbookLineageLabelsQuery } from '../../../../../../../gen-src/queries';
import { FeatureFlagsContext } from '../../../featureFlags/FeatureFlagsContext';
import { useContextWithOverride } from '../HookContext';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function useWorkbookLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, document, contextOverrides }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const { customSensitivityLabelsEnabled } = useContextWithOverride(FeatureFlagsContext, contextOverrides?.featureFlags);

  const [fire, { loading, error, data }] = useLazyQuery<WorkbookLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { luid: item.contentLuid ?? null, id: item.contentId ?? null, customSensitivityLabelsEnabled } }) }, [fire, item, customSensitivityLabelsEnabled]);

  const upstreamLabels = data?.items[0] ? data?.items[0].upstreamLabels : undefined;
  const inheritedByCandidates: InheritedLabelsFieldFragment[] | undefined = data?.items[0] ? data.items[0].embeddedDatasources?.flatMap(embeddedDatasource => embeddedDatasource.fields) : undefined;
  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream, inheritedByCandidates }) };
  return [invoke, result]
}
